import React, { useState, useEffect } from 'react'
import { ReactComponent as Cross } from "../../assets/img/cross.svg"
import OTPInput, { ResendOTP } from "otp-input-react";


const VerificationModal = ({ handleModal, handleResendCode, confirmVerification, loading }) => {
    const [OTP, setOTP] = useState("");
    const [timer, setTimer] = useState(120);
    const [isResendDisabled, setIsResendDisabled] = useState(true);
    const handleResend = () => {
        setTimer(120); // Restart timer
        setIsResendDisabled(true);
        handleResendCode()
    }

    useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
            return () => clearInterval(interval);
        } else {
            setIsResendDisabled(false);
        }
    }, [timer]);

    return (
        <div style={{ fontFamily: "Outfit", position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 1050, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
            <div
                className='d-flex flex-column justify-content-center align-items-center'
                style={{ backgroundColor: "#fff", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", padding: "30px 30px", width: "402px", position: "relative", maxHeight: '98vh', overflowY: 'auto', scrollbarWidth: "none" }}
            >
                <h1 style={{
                    fontWeight: 600,
                    fontSize: '24px',
                    fontFamily: "Outfit",
                    color: '#1C1C1C'
                }}>Enter Verification Code</h1>
                <span style={{
                    marginBottom: "30px",
                    color: '#828282',
                    fontWeight: 400,
                    fontSize: '16px',
                    textAlign: "center",
                    width: "80%"
                }}>We have sent a six digit verification code to your registered email.</span>
                <div onClick={handleModal} className=' position-absolute' style={{
                    right: '20px',
                    top: '20px',
                    cursor: "pointer"
                }}>
                    <Cross />
                </div>
                <OTPInput className="justify-content-between w-100" value={OTP} onChange={setOTP} autoFocus OTPLength={6} otpType="number" disabled={false}
                    inputStyles={{
                        marginRight: '0px',
                        border: "1px solid #CECECE",
                        borderRadius: "8px",
                        width: "49px",
                        height: "53px",
                        fontWeight: 500,
                        fontSize: '18px',
                        color: '#24252B',

                    }} />
                <div className='flex-column w-100 align-items-center' style={{ display: "flex", justifyContent: "center", marginTop: "40px", gap: '10px' }}>
                    <button
                        className=' w-100'
                        style={{ padding: "10px 20px", backgroundColor: "#362FD8", color: "#fff", border: "none", borderRadius: "6px" }}
                        onClick={() => confirmVerification(OTP)}
                        disabled={loading}
                    >
                        Confirm
                    </button>
                    <span style={{
                        color: '#828282',
                        fontWeight: 400,
                        fontSize: '16px',
                    }}>Did not get a code? <span style={{
                        color: isResendDisabled ? "#828282" : "#362FD8",
                        cursor: isResendDisabled ? "not-allowed" : "pointer",
                        pointerEvents: isResendDisabled ? "none" : "auto",
                    }} onClick={!isResendDisabled ? handleResend : undefined}>Resend code</span></span>
                    <span
                        style={{
                            color: '#1C1C1C',
                            fontWeight: 500,
                            fontSize: '16px',
                            lineHeight: '20.16px'
                        }}
                    > {timer} seconds</span>
                </div>
            </div>
        </div>
    )
}

export default VerificationModal